var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", dense: "", color: "primary", dark: "" } },
            [_c("v-toolbar-title", [_vm._v("New Quotation")])],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          !_vm.form.projectCode
                            ? _c("v-text-field", {
                                attrs: {
                                  clearable: "",
                                  "hide-details": "auto",
                                  label: "Subject (new project code)",
                                  outlined: "",
                                  dense: "",
                                  "error-messages":
                                    _vm.form.errors?.["data.subject"]
                                },
                                model: {
                                  value: _vm.form.data.subject,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.data, "subject", $$v)
                                  },
                                  expression: "form.data.subject"
                                }
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  "hide-details": "auto",
                                  label: "Subject",
                                  value: _vm.form.projectCode.description,
                                  outlined: "",
                                  dense: "",
                                  readonly: ""
                                }
                              })
                        ],
                        1
                      ),
                      !_vm.form.data.subject
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              !_vm.form.data.new_customer.name
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      "hide-details": "auto",
                                      "item-value": "id",
                                      "item-text": "code",
                                      label: "Project Code",
                                      items: _vm.projectCodes,
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      "no-filter": "",
                                      "search-input": _vm.projectCodeSearch,
                                      "return-object": "",
                                      "error-messages":
                                        _vm.form.errors?.[
                                          "data.project_code_id"
                                        ]
                                    },
                                    on: {
                                      "update:searchInput": function($event) {
                                        _vm.projectCodeSearch = $event
                                      },
                                      "update:search-input": function($event) {
                                        _vm.projectCodeSearch = $event
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function({ item }) {
                                            return [_vm._v(_vm._s(item.code))]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function({ item }) {
                                            return [
                                              _vm._v(" ("),
                                              _c("small", [
                                                _vm._v(_vm._s(item.code))
                                              ]),
                                              _vm._v(") "),
                                              _c("small", [
                                                _vm._v(
                                                  " - " +
                                                    _vm._s(item.description)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2461934447
                                    ),
                                    model: {
                                      value: _vm.form.projectCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "projectCode", $$v)
                                      },
                                      expression: "form.projectCode"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex",
                          staticStyle: { "align-items": "center" },
                          attrs: { cols: "12", md: "2" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-2 w-full",
                              attrs: { small: "", text: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.newCustomer = !_vm.newCustomer
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.newCustomer
                                        ? "mdi-account-search"
                                        : "mdi-account-plus"
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.newCustomer
                                      ? "Select Existing Customer"
                                      : "New Customer"
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _vm.newCustomer
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex",
                                  staticStyle: { gap: "10px" }
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      label: "Category",
                                      "hide-details": "auto",
                                      "item-value": "id",
                                      "item-text": item =>
                                        `(${item.id}) - ${item.name}`,
                                      items: _vm.customerCategories
                                    },
                                    model: {
                                      value:
                                        _vm.form.data.new_customer
                                          .customer_category_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.data.new_customer,
                                          "customer_category_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.data.new_customer.customer_category_id"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      label: "Company",
                                      "hide-details": "auto"
                                    },
                                    model: {
                                      value: _vm.form.data.new_customer.company,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.data.new_customer,
                                          "company",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.data.new_customer.company"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("v-autocomplete", {
                                attrs: {
                                  "hide-details": "auto",
                                  "item-value": "id",
                                  "item-text": "name",
                                  label: "Customer",
                                  items: _vm.customers,
                                  "search-input": _vm.customerSearch,
                                  "error-messages":
                                    _vm.form.errors?.["data.customer_id"],
                                  outlined: "",
                                  dense: "",
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    _vm.customerSearch = $event
                                  },
                                  "update:search-input": function($event) {
                                    _vm.customerSearch = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        _c("small", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              `(${_vm.highlightText(
                                                item.id,
                                                _vm.customerSearch
                                              )})`
                                            )
                                          }
                                        }),
                                        _vm._v("  -  "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.highlightText(
                                                item.name,
                                                _vm.customerSearch
                                              )
                                            )
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.form.data.customer_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.data, "customer_id", $$v)
                                  },
                                  expression: "form.data.customer_id"
                                }
                              })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              "hide-details": "auto",
                              label: "VAT Type",
                              items: _vm.vatTypes,
                              outlined: "",
                              dense: "",
                              "error-messages":
                                _vm.form.errors?.["data.vat_type"]
                            },
                            model: {
                              value: _vm.form.data.vat_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form.data, "vat_type", $$v)
                              },
                              expression: "form.data.vat_type"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "hide-details": "auto",
                              label: "Actual Date",
                              type: "date",
                              outlined: "",
                              dense: "",
                              "error-messages":
                                _vm.form.errors?.["data.actual_date"]
                            },
                            model: {
                              value: _vm.form.data.actual_date,
                              callback: function($$v) {
                                _vm.$set(_vm.form.data, "actual_date", $$v)
                              },
                              expression: "form.data.actual_date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "hide-details": "auto",
                              label: "Discount Rate",
                              type: "number",
                              outlined: "",
                              dense: "",
                              "error-messages":
                                _vm.form.errors?.["data.discount_rate"]
                            },
                            model: {
                              value: _vm.form.data.discount_rate,
                              callback: function($$v) {
                                _vm.$set(_vm.form.data, "discount_rate", $$v)
                              },
                              expression: "form.data.discount_rate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              "hide-details": "auto",
                              label: "Notes",
                              outlined: "",
                              dense: "",
                              "error-messages": _vm.form.errors?.["data.notes"]
                            },
                            model: {
                              value: _vm.form.data.notes,
                              callback: function($$v) {
                                _vm.$set(_vm.form.data, "notes", $$v)
                              },
                              expression: "form.data.notes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              "hide-details": "auto",
                              items: _vm.tacOptions,
                              loading: _vm.tacLoading,
                              "item-text": "alias",
                              "item-value": "id",
                              label: "Search / Select T&C Preset",
                              outlined: "",
                              dense: "",
                              clearable: "",
                              "return-object": "",
                              "error-messages":
                                _vm.form.errors?.["data.terms_and_conditions"]
                            },
                            on: { change: _vm.applyTac },
                            model: {
                              value: _vm.selectedTac,
                              callback: function($$v) {
                                _vm.selectedTac = $$v
                              },
                              expression: "selectedTac"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "12", md: "6" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary", small: "" },
                              on: { click: _vm.saveTac }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-content-save")
                              ]),
                              _vm._v(" Save as Preset ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "warning",
                                small: "",
                                disabled:
                                  !_vm.selectedTac || !_vm.selectedTac.id
                              },
                              on: { click: _vm.updateTac }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-pencil")
                              ]),
                              _vm._v(" Update Preset ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("strong", [_vm._v("Terms & Conditions")]),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.form.data.terms_and_conditions, function(tc, i) {
                      return _c(
                        "v-col",
                        { key: i, attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "", align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "5" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "hide-details": "auto",
                                          label: "Key",
                                          outlined: "",
                                          dense: ""
                                        },
                                        model: {
                                          value: tc.key,
                                          callback: function($$v) {
                                            _vm.$set(tc, "key", $$v)
                                          },
                                          expression: "tc.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "5" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "error-messages":
                                            _vm.form.errors?.[
                                              `data.terms_and_conditions.${tc.key}`
                                            ],
                                          "hide-details": "auto",
                                          label: "Value",
                                          outlined: "",
                                          dense: ""
                                        },
                                        model: {
                                          value: tc.value,
                                          callback: function($$v) {
                                            _vm.$set(tc, "value", $$v)
                                          },
                                          expression: "tc.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-right",
                                      attrs: { cols: "12", md: "2" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            color: "red",
                                            text: "",
                                            dark: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeTC(i)
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("mdi-delete")])],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: { small: "" },
                      on: { click: _vm.addTC }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v(" Add Term ")
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c("strong", [_vm._v("Items")]),
                  _c("v-data-table", {
                    staticClass: "mt-2",
                    attrs: {
                      "hide-default-footer": "",
                      headers: _vm.itemHeaders,
                      items: _vm.form.items,
                      dense: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.specs",
                        fn: function({ item }) {
                          return [
                            _c("span", [_vm._v(_vm._s(item.specs.join(" | ")))])
                          ]
                        }
                      },
                      {
                        key: "item.is_service",
                        fn: function({ value }) {
                          return [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  small: "",
                                  color: value ? "green" : "red"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(value ? "mdi-check" : "") + " "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function({ index }) {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "", color: "red" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem(index)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("mdi-delete")])],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "item.unit_price",
                        fn: function({ value }) {
                          return [_vm._v(_vm._s(_vm.currencyFormat(value)))]
                        }
                      },
                      {
                        key: "item.amount",
                        fn: function({ item }) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.currencyFormat(
                                  item.unit_price * item.quantity
                                )
                              )
                            )
                          ]
                        }
                      },
                      {
                        key: "body.append",
                        fn: function() {
                          return [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "5" }
                                },
                                [_vm._v("Sub Total")]
                              ),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyFormat(_vm.actualSubtotal)
                                    ) +
                                    " "
                                )
                              ]),
                              _c("td", [_vm._v(" ")])
                            ]),
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "5" }
                                },
                                [
                                  _vm._v(
                                    "Discount (" +
                                      _vm._s(_vm.discountPercent) +
                                      ")"
                                  )
                                ]
                              ),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currencyFormat(_vm.discount)) +
                                    " "
                                )
                              ]),
                              _c("td", [_vm._v(" ")])
                            ]),
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "5" }
                                },
                                [_vm._v("Total (vat ex)")]
                              ),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currencyFormat(_vm.totalVatEx)) +
                                    " "
                                )
                              ]),
                              _c("td", [_vm._v(" ")])
                            ]),
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "5" }
                                },
                                [
                                  _vm._v(
                                    "VAT (" +
                                      _vm._s(
                                        _vm.getVatSymbol(_vm.form.data.vat_type)
                                      ) +
                                      ")"
                                  )
                                ]
                              ),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyFormat(_vm.totalVatAmount)
                                    ) +
                                    " "
                                )
                              ]),
                              _c("td", [_vm._v(" ")])
                            ]),
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "5" }
                                },
                                [_vm._v(" Total ")]
                              ),
                              _c("th", { staticClass: "text-right" }, [
                                _c("strong", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currencyFormat(_vm.totalAmount)
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("td", [_vm._v(" ")])
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: { small: "" },
                      on: {
                        click: function($event) {
                          _vm.itemDialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v(" Add Item ")
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: { color: "primary" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v(" Save ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.itemDialog,
            callback: function($$v) {
              _vm.itemDialog = $$v
            },
            expression: "itemDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add Item")]),
              _c(
                "v-card-text",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: "10px" }
                },
                [
                  _c("v-combobox", {
                    attrs: {
                      "no-filter": "",
                      clearable: "",
                      "hide-details": "auto",
                      label: "Description",
                      items: _vm.quotationItems.data.map(d => d.description),
                      outlined: "",
                      dense: "",
                      "search-input": _vm.quotationItems.search
                    },
                    on: {
                      "update:search-input": [
                        function($event) {
                          return _vm.fetchQuotationItems()
                        },
                        function($event) {
                          return _vm.$set(_vm.quotationItems, "search", $event)
                        }
                      ],
                      "update:searchInput": function($event) {
                        return _vm.$set(_vm.quotationItems, "search", $event)
                      },
                      change: _vm.onQuotationItemChange
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c(
                                "h2",
                                { staticStyle: { "font-size": "14px" } },
                                [_vm._v(" " + _vm._s(item) + " ")]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "text-indent": "10px",
                                    "font-size": "10px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.quotationItemsMap
                                        .get(item)
                                        .specs.join(" | ")
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.newItem.description,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "description", $$v)
                      },
                      expression: "newItem.description"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "hide-details": "auto",
                      label: "Unit Price",
                      type: "number",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: _vm.newItem.unit_price,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "unit_price", $$v)
                      },
                      expression: "newItem.unit_price"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "hide-details": "auto",
                      label: "Quantity",
                      type: "number",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: _vm.newItem.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "quantity", $$v)
                      },
                      expression: "newItem.quantity"
                    }
                  }),
                  _c("v-textarea", {
                    attrs: {
                      "hide-details": "auto",
                      label: "Specs",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: _vm.newItem.specsText,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "specsText", $$v)
                      },
                      expression: "newItem.specsText"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      "hide-details": "auto",
                      label: "Is Service",
                      dense: ""
                    },
                    model: {
                      value: _vm.newItem.is_service,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "is_service", $$v)
                      },
                      expression: "newItem.is_service"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.itemDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.addItemConfirm }
                    },
                    [_vm._v(" Add ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }